<template>
  <div>
    <v-subheader>Reportes</v-subheader>
    <date-picker
      label="Fecha inicio"
      v-model="fechaFrom"
    ></date-picker>
    <date-picker
      label="Fecha fin"
      v-model="fechaTo"
    ></date-picker>
    <v-btn
      color="primary"
      :loading="loading"
      @click="onSubmitFetch"
      block
    >
      Buscar
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DatePicker from '@/components/DatePicker'
export default {
  name: 'ReportesSelectComponent',
  components: {
    'date-picker': DatePicker,
  },
  computed: {
    ...mapGetters('ReportesVentas', [
      'loading', 'filters'
    ]),
    fechaFrom: {
      get() {
        return this.filters.fecha_from
      },
      set(value) {
        this.setFilters({
          ...this.filters,
          fecha_from: value,
        })
      },
    },
    fechaTo: {
      get() {
        return this.filters.fecha_to
      },
      set(value) {
        this.setFilters({
          ...this.filters,
          fecha_to: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('ReportesVentas', ['onFetch']),
    ...mapMutations('ReportesVentas', ['setFilters']),
    onSubmitFetch(event) {
      event.preventDefault();
      this.onFetch();
    },
  },
}
</script>
